import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=b5c8d1d4&scoped=true&"
import script from "./file-list.vue?vue&type=script&lang=js&"
export * from "./file-list.vue?vue&type=script&lang=js&"
import style0 from "./file-list.vue?vue&type=style&index=0&id=b5c8d1d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c8d1d4",
  null
  
)

export default component.exports